import '../styles/Description.css';

export const Description = ({
    local,
    title,
    subtitle,
    text,
    reverse,
    image
}) => {
    return (
        <section className="sl-description-section">
            <div
                className={`sl-description-container ${
                    reverse && 'flex-row-reverse'
                }`}
            >
                <div className="sl-image-container">
                    <img
                        src={image}
                        crossorigin="anonymous"
                        alt="Descrição da imagem"
                        className="sl-description-image"
                    />
                </div>
                <div className="sl-description-text">
                    <div className="sl-description-widget-wrap">
                        <div className="sl-description-widget-container">
                            <h2 className="sl-description-heading-title-1">
                                {local}
                            </h2>
                        </div>
                        <div className="sl-description-widget-container">
                            <h2 className="sl-description-heading-title-2">
                                {title}
                                <br />
                                <span
                                    style={{
                                        fontSize: '0.72em',
                                        fontWeight: '200'
                                    }}
                                >
                                    {subtitle}
                                </span>
                            </h2>
                        </div>
                        <div className="sl-description-fulltext-container">
                            <div className="sl-description-widget-container">
                                {text}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
